import React from 'react';

export default React.createClass({
  render() {
    const img = require('../../assets/images/globaljetlogowhite.png');
    return(<span><img src={img} style={{ height: "40px" }}/></span>)
  }
});
